<div class="lum-c-auth-error">
  <img
    class="lum-c-auth-error__logo"
    src="/assets/logo/png/luminous-horiz-rgb-fullcolor-small.png"
    alt="Luminous Logo"
  />
  <h3 class="lum-c-auth-error__message">Error Logging In</h3>
  <div *ngIf="errorType == 'usernotfound'">
    <p>The email address used could not be matched to a user in Luminous.</p>
    <p
      >Make sure a user exists in your Luminous account with the same email and try
      again.</p
    >
  </div>
  <div *ngIf="!errorType">
    <p
      >An unknown error occurred while trying to log in. If this continues, contact
      support.</p
    >
  </div>
  <a href="{{ loginUrl }}" class="lum-button lum-button--link">Back to Login</a>
</div>
